import { menuTagihan } from '../action-types';

const initialState = {
  data: null,
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case menuTagihan.FETCH_MENUTAGIHAN:
      return {
        ...state,
        isFetching: true,
      };
    case menuTagihan.GET_MENUTAGIHAN:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    default:
      return state;
  }
};
